import React, { useState, useEffect } from "react";
import { Container, Header, Heading, Content } from "../Summarize/Style";
import { useNavigate, useOutletContext } from "react-router-dom";
import BackIcon from "../../assets/back-icon.svg";
// import MenuItem from "@mui/material/MenuItem";
// import SearchIcon from "../../assets/searchicon.svg";
// import InputAdornment from "@mui/material/InputAdornment";
import {
  integrations,
  // StyledTextField,
  // StyledSelect,
} from "../Constants/Constants";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import {
  SearchContainer,
  IntegrationsGrid,
  IntegrationCard,
  CardTitle,
  AuthorizeButton,
  SubText,
} from "./style";
import Calendar from "./calendar";
import Drive from "./Drive";
import Email from "./Email";
import Microsoft from "./microsoft";
import axios from "axios";
import CustomEmail from "./customEmail";
import MicrosoftDrive from "./microsoftDrive";

import { useTranslation } from "react-i18next";

const Integrations = () => {
  const { t } = useTranslation();
  const { isSidebarOpen } = useOutletContext();
  const navigate = useNavigate();

  // const [sortBy, setSortBy] = useState("");

  const [user, setUser] = useState(null);
  const [provider, setProvider] = useState([]);
  const [isGoogleConnected, setIsGoogleConnected] = useState(false);
  const [isMicrosoftConnected, setIsMicrosoftConnected] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("user_token");
    const id = localStorage.getItem("user_id");
    if (token && id) {
      const userData = { token, id: Number(id) };
      setUser(userData);
      handleCheckEmailProvider(userData);
    }
  }, []);

  const handleCheckEmailProvider = async (userData) => {
    const { token, id } = userData || user || {};
    if (!token || !id) return;
    try {
      const res = await axios.get(
        `https://api.emailflowpro.aivoria.nl/api/provider/user/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      console.log("Check Email Provider Response", res.data);
      if (res.data.emailProvider.length > 0) {
        setProvider(res.data.emailProvider);
        const isGoogleIntegrated = res.data.emailProvider.some(
          (item) => item.email_provider === "oAuthGoogle" && item.feature_type === "integration",
        );
        setIsGoogleConnected(isGoogleIntegrated);
        const isMicrosoftIntegrated = res.data.emailProvider.some(
          (item) => item.email_provider === "oAuthMicrosoft" && item.feature_type === "integration",
        );
        setIsMicrosoftConnected(isMicrosoftIntegrated);
      } else {
        setProvider([{ email_provider: "none" }]);
        setIsGoogleConnected(false);
        setIsMicrosoftConnected(false);
      }
    } catch (error) {
      console.log("Check Email Provider Error", error);
    }
  };

  // Map backend/constant names to translation keys
  const getTranslationKey = (name) => {
    switch (name) {
      case "Gmail": return "gmail";
      case "Custom Email": return "customEmail";
      case "Google Calendar": return "googleCalendar";
      case "Google Drive": return "googleDrive";
      case "Outlook": return "outlook";
      case "Microsoft OneDrive": return "oneDrive";
      case "Dropbox (Coming Soon)": return "dropbox";
      case "HubSpot (Coming Soon)": return "hubspot";
      default: return "";
    }
  };

  return (
    <Container isOpen={isSidebarOpen} style={{ marginRight: "1.4rem" }}>
      <Header style={{ alignItems: "center", justifyContent: "space-between" }}>
        <div
          style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img src={BackIcon} alt={t("integrations.back")} />

          <Heading style={{ marginBottom: 0 }}>
            {t("integrations.title")}
          </Heading>

          <Tooltip
            title={t("integrations.tooltip")}
            placement="top"
          >
            <InfoCircleOutlined
              style={{
                fontSize: 14,
                color: "#8c8c8c",
                cursor: "pointer",
              }}
              onClick={(e) => e.stopPropagation()} // prevent navigation
            />
          </Tooltip>
        </div>
      </Header>

      <Content
        style={{
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          overflowY: "auto",
          padding: "1.25rem 1rem",
          gap: "1.25rem",
        }}
      >
        <IntegrationsGrid>
          {integrations.map((integration, index) => {
            const key = getTranslationKey(integration.name);
            const translatedIntegration = key ? {
              ...integration,
              name: t(`integrations.${key}.name`),
              description: t(`integrations.${key}.description`)
            } : integration;

            if (integration.name === "Google Calendar") {
              return (
                <Calendar
                  key={index}
                  integration={translatedIntegration}
                  index={index}
                  isGoogleConnected={isGoogleConnected}
                  refresh={handleCheckEmailProvider}
                />
              );
            } else if (integration.name === "Google Drive") {
              return (
                <Drive
                  key={index}
                  integration={translatedIntegration}
                  index={index}
                  isGoogleConnected={isGoogleConnected}
                  refresh={handleCheckEmailProvider}
                />
              );
            } else if (integration.name === "Gmail") {
              return (
                <Email
                  key={index}
                  integration={translatedIntegration}
                  index={index}
                  user={user}
                  provider={provider}
                  isGoogleConnected={isGoogleConnected}
                  refresh={handleCheckEmailProvider}
                />
              );
            } else if (integration.name === "Outlook") {
              return (
                <Microsoft
                  key={index}
                  integration={translatedIntegration}
                  index={index}
                  user={user}
                  provider={provider}
                  isMicrosoftConnected={isMicrosoftConnected}
                  refresh={handleCheckEmailProvider}
                />
              );
            } else if (integration.name === "Custom Email") {
              return (
                <CustomEmail
                  key={index}
                  integration={translatedIntegration}
                  index={index}
                  provider={provider}
                  refresh={handleCheckEmailProvider}
                />
              );
            }
            return null;
          })}
        </IntegrationsGrid>
      </Content>
    </Container>
  );
};

export default Integrations;
